import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { LanguageService } from './language.service';
import { map, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private readonly defaultLang = 'en_AU';
  private translations = new BehaviorSubject<any>({});
  private currentTranslations: any = {};

  constructor(
    private readonly translate: TranslateService,
    private http: HttpClient,
    private languageService: LanguageService
  ) {
    this.languageService.currentLang$.subscribe((lang) => {
      // console.log('Language changed in TranslationService:', lang);
      this.loadTranslations(lang);
    });
  }

  getCurrentLang(): string {
    return this.translate.currentLang || this.defaultLang;
  }

  private loadTranslations(lang: string): void {
    // console.log('Loading translations for language:', lang);
    this.http
      .get<any>(`assets/i18n/${lang}.json`)
      .pipe(
        tap((translations) => {
          // console.log('Loaded translations:', translations);
        })
      )
      .subscribe(
        (translations) => {
          // console.log('Setting translations for language:', lang);
          this.currentTranslations = translations;
          this.translations.next(translations);
        },
        (error) => {
          console.error(`Error loading translations for ${lang}:`, error);
        }
      );
  }

  getCurrentTranslations(): Observable<any> {
    return this.translations.asObservable().pipe(
      tap((translations) => {
        // console.log('Getting current translations:', translations);
      })
    );
  }

  getTranslation(key: string): Observable<any> {
    return this.translations.pipe(
      map((translations) => {
        const value = translations[key] || key;
        // console.log(`Getting translation for key: ${key}`, value);
        return value;
      })
    );
  }
}
